import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Device_Interface, Empty_Device_Interface } from 'src/app/Interface/Device_Interface';
import { Empty_Tariff_Interface, Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PriceService } from 'src/app/Service/Price/Price.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';

@Component({
  selector: 'app-TariffAdd',
  templateUrl: './TariffAdd.component.html',
  styleUrls: ['./TariffAdd.component.scss']
})
export class TariffAddComponent implements OnInit {

  constructor(
    private Tariff_Service:TariffService,
    private Nav_Service:NavService,
    private Device_Service:DeviceService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService,
    private Price_Service:PriceService,
  ) { }

  ngOnInit() {

    this.AddNewTariff=new FormGroup({
      id :new FormControl(),
      Tariff:new FormControl(null,Validators.required),
      TariffAlpah:new FormControl(null,Validators.required),
      Tariff_Expert:new FormControl(null,Validators.required),
      Tariff_Hazineh:new FormControl(null,Validators.required),
      Tariff_ExpertAlpah:new FormControl(null,Validators.required),
      Dsc:new FormControl(null,Validators.required),
      t1:new FormControl(null,Validators.required),
      t2:new FormControl(null,Validators.required),
      t3:new FormControl(null,Validators.required),
    })


    this.Nav_Service.CheckValidPage(49).subscribe(
      data=>{

      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  AddNewTariff:FormGroup;

  get_Form_Dsc(){
    return this.AddNewTariff.get('Dsc') as FormControl;
  }

  get_Form_Tariff(){
    return this.AddNewTariff.get('Tariff') as FormControl;
  }

  get_Form_TariffAlpah(){
    return this.AddNewTariff.get('TariffAlpah') as FormControl;
  }

  get_Form_Tariff_Expert(){
    return this.AddNewTariff.get('Tariff_Expert') as FormControl;
  }

  get_Form_Tariff_ExpertAlpah(){
    return this.AddNewTariff.get('Tariff_ExpertAlpah') as FormControl;
  }

  get_Form_Tariff_Hazineh(){
    return this.AddNewTariff.get('Tariff_Hazineh') as FormControl;
  }

  get_Form_t1(){
    return this.AddNewTariff.get('t1') as FormControl;
  }

  get_Form_t2(){
    return this.AddNewTariff.get('t2') as FormControl;
  }

  get_Form_t3(){
    return this.AddNewTariff.get('t3') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitAddNewTariff(){
    var Record:Tariff_Interface =Empty_Tariff_Interface()
    Record.id=0
    Record.device_id=this.Data_Seleted_Record.id
    Record.tariff=Number(this.get_Form_Tariff().value)
    Record.tariff_expert=Number(this.get_Form_Tariff_Expert().value)
    Record.tariff_hazineh=Number(this.get_Form_Tariff_Hazineh().value)
    Record.dsc=this.get_Form_Dsc().value
    
    Record.t1=Number(this.get_Form_t1().value)
    Record.t2=Number(this.get_Form_t2().value)
    Record.t3=Number(this.get_Form_t3().value)
    
    this.InProccessing=true
    this.Tariff_Service.AddTariff(Record).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("توضیحات وارد شده ، در لیست وجود دارد")
        }
        else{
          this.AddNewTariff.reset()
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  Tariff_Change(){
    this.Price_Service.GetPriceAlphabet(this.get_Form_Tariff().value).subscribe(
      data=>{
        this.get_Form_TariffAlpah().setValue(data['price'])
      }
    )
  }

  Tariff_Expert_Change(){
    this.Price_Service.GetPriceAlphabet(this.get_Form_Tariff_Expert().value).subscribe(
      data=>{
        this.get_Form_Tariff_ExpertAlpah().setValue(data['price'])
      }
    )
  }


    //#region  دستگاه

    modalRef_Device: any;
    page:number=0

    ProcssingDevice:boolean=false

    Search_Name_Device_Table:string=''
    Search_Code_Device_Table:string=''

    openModal_Device(template: TemplateRef<any>) {
      this.modalRef_Device = this.modalService.show(template);
    }

    DataList_Device:Array<Device_Interface>=[]
    Data_Seleted_Record:Device_Interface=Empty_Device_Interface()


    ReadData_Device_KeySearch_Timer:any
    ReadData_Device_KeySearch(){

      if (this.ReadData_Device_KeySearch_Timer) {
        clearTimeout(this.ReadData_Device_KeySearch_Timer);
        this.ReadData_Device_KeySearch_Timer = null;
    }

    this.ReadData_Device_KeySearch_Timer = setTimeout(function (){
      this.ReadData_Device()
    }.bind(this), 1000);

    }

    ReadData_Device(){


      if(!this.Search_Name_Device_Table)
      {
        this.DataList_Device=[]
      }
      else{
        this.ProcssingDevice=true
        this.Device_Service.GetSearchCalibration(this.Search_Name_Device_Table,this.Search_Code_Device_Table).subscribe(
          data=>{
            this.DataList_Device=data
            this.ProcssingDevice=false
          },error=>{
            // AuthInterceptor owns authentication; feature errors must preserve credentials.

          }
        )
      }
    }

    Set_Selected_Device_Record(item){
      this.Data_Seleted_Record=item
      this.modalRef_Device.hide()
    }

    //#endregion




}
